import { render, staticRenderFns } from "./Post.htm?vue&type=template&id=6fe1b042&scoped=true&external"
import script from "./Post.js?vue&type=script&lang=js&external"
export * from "./Post.js?vue&type=script&lang=js&external"
import style0 from "./Post.scss?vue&type=style&index=0&id=6fe1b042&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe1b042",
  null
  
)

export default component.exports